import React, { useState, useEffect } from 'react';
import EditEventStyles from './EditUSP.module.css';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setNotifications } from '../../state/GlobalState';
import { setNotificationCount } from '../../state/GlobalState';
import { fetchNotifications } from '../../state/GlobalState';

const EditUSP = () => {
  const location = useLocation();
  const data = location.state;
  // console.log(data);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [eventData, setEventData] = useState({
    uspName: '',
    uspDesc: '',
  });

  const count = useSelector((state) => state.globalData.notificationCount);

  useEffect(() => {
    // Update the state with initial values from data
    setEventData({
      uspName: data.uspName,
      uspDesc: data.uspDesc,
    });
  }, [data]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setEventData({ ...eventData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const eventResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/usp/updateUsp/${data.uspId}`,
        eventData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // console.log('USP Updated.');
      // console.log(eventResponse);

      dispatch(fetchNotifications());

      dispatch(
        setNotificationCount({
          count: count + 1,
        })
      );

      alert('USP Updated.');
      navigate('/usp');
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={EditEventStyles.editEventMain}>
      <div className={EditEventStyles.editEventContent}>
        <form action="" className={EditEventStyles.editEventForm} onSubmit={handleSubmit}>
          <label className={EditEventStyles.editEventFormLabel}>Name</label>
          <input
            className={EditEventStyles.editEventFormText}
            type="text"
            value={eventData.uspName}
            name="uspName"
            onChange={handleInputChange}
          />
          <label className={EditEventStyles.editEventFormLabel}>Description</label>
          <textarea
            className={EditEventStyles.editEventFormDesc}
            value={eventData.uspDesc}
            name="uspDesc"
            onChange={handleInputChange}
          />
          <Button variant="contained" type="submit" className={EditEventStyles.saveChanges}>
            Save changes
          </Button>
        </form>
      </div>
    </div>
  );
};

export default EditUSP;
